import React, { useState, useEffect, useMemo, useRef } from 'react';
import { apiHolder, apis, getIn18Text } from 'api';
import Button from '@lingxi-common-component/sirius-ui/Button';
import Tooltip from '@lingxi-common-component/sirius-ui/Tooltip';
import { ReactComponent as DeleteIcon } from '@/images/icons/modal_close_temp.svg';
import { ReactComponent as Done } from '@/images/icons/disk/done.svg';
import { createNiceModal, useNiceModal } from '@web-common/components/UI/NiceModal/NiceModal';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { handleBackEndPaid } from '../../util';
import styles from './index.module.scss';
import Toast from '@web-common/components/UI/Message/SiriusMessage';
const accountApi = apiHolder.api.requireLogicalApi(apis.accountApiImpl);
const trackApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
const productAuthApi = apiHolder.api.requireLogicalApi(apis.productAuthApiImpl);
const eventApi = apiHolder.api.getEventApi();
const systemApi = apiHolder.api.getSystemApi();
const isElectron = systemApi.isElectron();
export const useFreeWriteMailErrorHandler = () => {
    const productVersionId = useRef('others');
    const paidGuideModal = useNiceModal('paidGuide');
    useEffect(() => {
        productAuthApi.doGetProductVersion().then(res => {
            productVersionId.current = res.productVersionId;
        });
    }, []);
    return (ev) => {
        if (productVersionId.current === 'free') {
            if (ev.eventData.code === 'FA_MTA_REJECTED5520') {
                paidGuideModal.show({ errType: '1', origin: '写信页' });
                eventApi.confirmEvent(ev);
                return true;
            }
            else if (ev.eventData.code === 'FA_OVERFLOW' && ev.eventData.overflowReason === 'pref_smtp_max_num_rcpts') {
                paidGuideModal.show({ errType: '2', origin: '写信页' });
                eventApi.confirmEvent(ev);
                return true;
            }
            else if (ev.eventData.code === 'FA_MTA_REJECTED5530') {
                paidGuideModal.show({ errType: '3', origin: '写信页' });
                eventApi.confirmEvent(ev);
                return true;
            }
            else if (ev.eventData.code === 'FA_OVERFLOW' && ev.eventData.overflowReason === 'pref_smtp_max_send_mail_size') {
                paidGuideModal.show({ errType: '4', origin: '写信页' });
                eventApi.confirmEvent(ev);
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
};
const Inform = props => {
    const { visibleAdmin, informContent } = props;
    return (React.createElement(React.Fragment, null, visibleAdmin ? ('升级至付费版，') : (React.createElement(React.Fragment, null,
        "\u53EF",
        React.createElement(Tooltip, { title: informContent },
            React.createElement("span", { className: styles.inform }, "\u90AE\u4EF6\u901A\u77E5")),
        "\u7BA1\u7406\u5458\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\uFF0C"))));
};
const InformContentPrefix = () => {
    return (React.createElement(React.Fragment, null,
        "\u4EE5\u4E0B\u4E3A\u90AE\u4EF6\u5185\u5BB9",
        React.createElement("br", null),
        "\u7BA1\u7406\u5458\uFF0C\u4F60\u597D",
        React.createElement("br", null)));
};
const PaidGuide = props => {
    const { setSuccessModalVisible, visibleAdmin } = props;
    const [maxNumRcpts, setMaxNumRcpts] = useState(10);
    const [maxNumRcptsOfDay, setMaxNumRcptsOfDay] = useState(100);
    const [maxSendMailSize, setMaxSendMailSize] = useState(20 * 1024);
    const [maxSendMailNum, setMaxSendMailNum] = useState(100);
    const [loading, setLoading] = useState(false);
    const [originEn, setOriginEn] = useState('');
    const modal = useNiceModal('paidGuide');
    const TipsContent = useMemo(() => {
        let tip = React.createElement(React.Fragment, null);
        let informContent = React.createElement(React.Fragment, null);
        setOriginEn('other');
        if (modal.args.errType === '1') {
            setOriginEn('max_mail_num');
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u5F53\u524D\u514D\u8D39\u7248\u7684\u53D1\u4FE1\u4E0A\u9650\uFF1A",
                maxSendMailNum,
                "\u5C01/\u5929/\u8D26\u53F7\uFF0C\u65E0\u6CD5\u6EE1\u8DB3\u65E5\u5E38\u53D1\u4FE1\u9700\u6C42\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\u63D0\u9AD8\u53D1\u4FE1\u91CF\uFF0C\u8C22\u8C22\uFF01"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u7248\u672C\u4E3A\uFF1A\u514D\u8D39\u7248\uFF0C\u6700\u591A\u652F\u6301\u5916\u53D1",
                React.createElement("span", null, maxSendMailNum),
                "\u5C01/\u5929",
                React.createElement("br", null),
                React.createElement(Inform, { visibleAdmin: visibleAdmin, informContent: informContent }),
                "\u63D0\u5347\u53D1\u4FE1\u4E0A\u9650\uFF0C\u6700\u9AD8\u53EF\u8FBE2500\u5C01/\u5929"));
        }
        else if (modal.args.errType === '2') {
            setOriginEn('max_rcpt_num');
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u5F53\u524D\u514D\u8D39\u7248\u5355\u5C01\u90AE\u4EF6\u6700\u591A\u53EF\u6DFB\u52A0",
                maxNumRcpts,
                "\u4E2A\u6536\u4EF6\u4EBA\uFF0C\u65E0\u6CD5\u6EE1\u8DB3\u65E5\u5E38\u53D1\u4FE1\u9700\u6C42\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\u63D0\u9AD8\u6536\u4EF6\u4EBA\u6570\uFF0C\u8C22\u8C22\uFF01"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u7248\u672C\u4E3A\uFF1A\u514D\u8D39\u7248\uFF0C\u5355\u5C01\u90AE\u4EF6\u6700\u591A\u53EF\u6DFB\u52A0",
                React.createElement("span", null, maxNumRcpts),
                "\u4E2A\u6536\u4EF6\u4EBA",
                React.createElement("br", null),
                React.createElement(Inform, { visibleAdmin: visibleAdmin, informContent: informContent }),
                "\u63D0\u5347\u53D1\u4FE1\u4EBA\u6570\u4E0A\u9650\uFF0C\u6700\u9AD8\u53EF\u8FBE500\u4EBA/\u5C01"));
        }
        else if (modal.args.errType === '3') {
            setOriginEn('max_rcpt_num');
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u5F53\u524D\u514D\u8D39\u7248\u6BCF\u65E5\u53D1\u4FE1\u7684\u6536\u4EF6\u4EBA\u603B\u6570\u4E0A\u9650\u4E3A\uFF1A",
                maxNumRcptsOfDay,
                "\u4EBA\uFF0C\u65E0\u6CD5\u6EE1\u8DB3\u65E5\u5E38\u53D1\u4FE1\u9700\u6C42\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\u63D0\u9AD8\u6536\u4EF6\u4EBA\u6570\uFF0C\u8C22\u8C22\uFF01"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u7248\u672C\u4E3A\uFF1A\u514D\u8D39\u7248\uFF0C\u6BCF\u65E5\u53D1\u4FE1\u7684\u6536\u4EF6\u4EBA\u603B\u6570\u4E0A\u9650\u4E3A\uFF1A",
                React.createElement("span", null, maxNumRcptsOfDay),
                "\u4EBA",
                React.createElement("br", null),
                React.createElement(Inform, { visibleAdmin: visibleAdmin, informContent: informContent }),
                "\u63D0\u5347\u53D1\u4FE1\u4E0A\u9650\uFF0C\u6700\u9AD8\u53EF\u8FBE2500\u4EBA/\u5929"));
        }
        else if (modal.args.errType === '4') {
            setOriginEn('max_rcpt_num');
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u5F53\u524D\u514D\u8D39\u7248\u5355\u5C01\u90AE\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7",
                Math.floor(maxSendMailSize / 1024),
                "M\uFF0C\u65E0\u6CD5\u6EE1\u8DB3\u65E5\u5E38\u53D1\u4FE1\u9700\u6C42\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\u63D0\u9AD8\u5355\u5C01\u90AE\u4EF6\u5927\u5C0F\uFF0C\u8C22\u8C22\uFF01"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u7248\u672C\u4E3A\uFF1A\u514D\u8D39\u7248\uFF0C\u5355\u5C01\u90AE\u4EF6\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7",
                React.createElement("span", null, Math.floor(maxSendMailSize / 1024)),
                "M",
                React.createElement("br", null),
                React.createElement(Inform, { visibleAdmin: visibleAdmin, informContent: informContent }),
                "\u63D0\u5347\u5355\u5C01\u90AE\u4EF6\u5927\u5C0F\uFF0C\u6700\u9AD8\u53EF\u8FBE100M/\u5C01"));
        }
        else if (modal.args.errType === '41') {
            setOriginEn('max_rcpt_num');
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u5F53\u524D\u514D\u8D39\u7248\u5355\u5C01\u90AE\u4EF6\u5927\u5C0F\u6709\u9650\u5236\uFF0C\u65E0\u6CD5\u6EE1\u8DB3\u65E5\u5E38\u53D1\u4FE1\u9700\u6C42\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\u63D0\u9AD8\u5355\u5C01\u90AE\u4EF6\u5927\u5C0F\uFF0C\u8C22\u8C22\uFF01"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u7248\u672C\u4E3A\uFF1A\u514D\u8D39\u7248\uFF0C\u5F53\u524D\u90AE\u4EF6\u5DF2\u8D85\u8FC7\u5927\u5C0F\u9650\u5236",
                React.createElement("br", null),
                React.createElement(Inform, { visibleAdmin: visibleAdmin, informContent: informContent }),
                "\u53D1\u9001\u8D85\u5927\u90AE\u4EF6"));
        }
        else if (modal.args.errType === '5') {
            setOriginEn('front_end');
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u4F01\u4E1A\u5F53\u524D\u4E3A\u514D\u8D39\u7248\uFF0C\u65E0\u6CD5\u6EE1\u8DB3\u65E5\u5E38\u53D1\u4FE1\u9700\u6C42\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\u4EAB\u53D7\u65E0\u9650\u90AE\u7BB1\u5BB9\u91CF\u3001\u62E5\u6709\u90AE\u4EF6\u9605\u8BFB\u72B6\u6001\u8FFD\u8E2A\u7B49\u9AD8\u7EA7\u80FD\u529B"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u7248\u672C\u4E3A\uFF1A\u514D\u8D39\u7248",
                React.createElement("br", null),
                React.createElement(Inform, { visibleAdmin: visibleAdmin, informContent: informContent }),
                "\u5373\u53EF\u4EAB\u53D7\u5B89\u5168\u3001\u7A33\u5B9A\u7684\u4F01\u4E1A\u90AE\u7BB1\u670D\u52A1\uFF0C\u5305\u62EC\u65E0\u9650\u90AE\u7BB1\u5BB9\u91CF\u3001\u62E5\u6709\u90AE\u4EF6\u9605\u8BFB\u72B6\u6001\u8FFD\u8E2A\u7B49\u9AD8\u7EA7\u80FD\u529B"));
        }
        else if (modal.args.errType === '6') {
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u4F01\u4E1A\u5F53\u524D\u4E3A\u514D\u8D39\u7248\uFF0C\u65E0\u6CD5\u4F7F\u7528\u90AE\u4EF6AI\u80FD\u529B\uFF0C\u6EE1\u8DB3\u65E5\u5E38\u53D1\u4FE1\u9700\u6C42\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\uFF0C\u4F7F\u7528\u90AE\u4EF6AI\u80FD\u529B"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u90AE\u7BB1\u7248\u672C\u65E0\u6CD5\u4F7F\u7528AI\u529F\u80FD\u3002",
                React.createElement("br", null),
                "\u5347\u7EA7\u81F3\u5C0A\u4EAB\u7248\uFF0C\u5373\u53EF\u4EAB\u53D7\u6240\u6709\u90AE\u4EF6AI\u80FD\u529B\u3002"));
        }
        else if (modal.args.errType === '7') {
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u4F01\u4E1A\u5F53\u524D\u4E3A\u514D\u8D39\u7248\uFF0C\u65E0\u6CD5\u4F7F\u7528\u90AE\u4EF6\u5DF2\u8BFB\u63D0\u9192\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\uFF0C\u5BF9\u65B9\u8BFB\u4FE1\u540E\u7CFB\u7EDF\u53EF\u901A\u8FC7\u6D88\u606F\u53CA\u65F6\u901A\u77E5\uFF0C\u6EE1\u8DB3\u65E5\u5E38\u529E\u516C\u9700\u6C42"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u7248\u672C\u4E3A\uFF1A\u514D\u8D39\u7248\uFF0C\u65E0\u6CD5\u4F7F\u7528\u90AE\u4EF6\u5DF2\u8BFB\u63D0\u9192",
                React.createElement("br", null),
                React.createElement(Inform, { visibleAdmin: visibleAdmin, informContent: informContent }),
                "\u5BF9\u65B9\u8BFB\u4FE1\u540E\u7CFB\u7EDF\u53EF\u901A\u8FC7\u6D88\u606F\u53CA\u65F6\u901A\u77E5"));
        }
        else if (modal.args.errType === '8') {
            setOriginEn('mail_use_read_status');
            informContent = (React.createElement(React.Fragment, null,
                React.createElement(InformContentPrefix, null),
                "\u4F01\u4E1A\u5F53\u524D\u4E3A\u514D\u8D39\u7248\uFF0C\u65E0\u6CD5\u4F7F\u7528\u90AE\u4EF6\u9605\u8BFB\u72B6\u6001\u8FFD\u8E2A\u529F\u80FD\uFF0C\u671F\u671B\u80FD\u5347\u7EA7\u81F3\u4ED8\u8D39\u7248\uFF0C\u53D1\u4FE1\u540E\u53EF\u53CA\u65F6\u67E5\u770B\u90AE\u4EF6\u9605\u8BFB\u72B6\u6001\uFF0C\u6EE1\u8DB3\u65E5\u5E38\u529E\u516C\u9700\u6C42"));
            tip = (React.createElement(React.Fragment, null,
                "\u5F53\u524D\u7248\u672C\u4E3A\uFF1A\u514D\u8D39\u7248\uFF0C\u65E0\u6CD5\u4F7F\u7528\u90AE\u4EF6\u9605\u8BFB\u72B6\u6001\u8FFD\u8E2A\u529F\u80FD",
                React.createElement("br", null),
                React.createElement(Inform, { visibleAdmin: visibleAdmin, informContent: informContent }),
                "\u53D1\u4FE1\u540E\u53EF\u53CA\u65F6\u67E5\u770B\u90AE\u4EF6\u9605\u8BFB\u72B6\u6001"));
        }
        else {
            tip = React.createElement(React.Fragment, null);
        }
        return React.createElement("p", { className: styles.tipBody }, tip);
    }, [modal.args.errType, visibleAdmin, maxNumRcpts, maxNumRcptsOfDay, maxSendMailSize, maxSendMailNum]);
    const getTrackSource = (type) => {
        let source = '';
        if (type === '1') {
            source = '对外发信数量超过上限';
        }
        else if (type === '2') {
            source = '单封邮件收件人数量超过上限';
        }
        else if (type === '3') {
            source = '每日收件人数量超过上限';
        }
        else if (type === '4') {
            source = '单封邮件大小超过上限';
        }
        else if (type === '5') {
            source = 'web端首页顶部引导付费条';
        }
        else if (type === '6') {
            source = 'AI写信 AI润色';
        }
        else if (type === '7') {
            source = '已读提醒';
        }
        else if (type === '8') {
            source = '邮件阅读状态追踪';
        }
        return source;
    };
    useEffect(() => {
        if (!modal.hiding) {
            trackApi.track('pcMail_show_error_free', {
                type: visibleAdmin ? '管理员' : '成员',
                origin: modal.args.origin,
                source: modal.args.source || getTrackSource(modal.args.errType),
            });
        }
    }, [modal.hiding]);
    const modalConfirm = () => {
        if (visibleAdmin) {
            trackApi.track('pcMail_click_error_free', {
                type: visibleAdmin ? '管理员' : '成员',
                origin: modal.args.origin,
                source: modal.args.source || getTrackSource(modal.args.errType),
                buttonName: '立即购买',
            });
            modal.hide();
            handleBackEndPaid({
                source: 'siris_' + originEn,
            });
        }
        else if (!loading) {
            setLoading(true);
            accountApi
                .sendCosUpgrade(parseInt(modal.args.errType) || 1)
                .then(() => {
                trackApi.track('pcMail_click_error_free', {
                    type: visibleAdmin ? '管理员' : '成员',
                    origin: modal.args.origin,
                    source: getTrackSource(modal.args.errType),
                    buttonName: '发邮件通知管理员',
                });
                modal.hide();
                setSuccessModalVisible(true);
            })
                .catch(() => {
                Toast.warn({
                    content: getIn18Text('CHUCUOLE，QINGSHAOHOU'),
                    duration: 3,
                });
            })
                .finally(() => {
                setLoading(false);
            });
        }
    };
    const modalClose = () => {
        trackApi.track('pcMail_click_error_free', {
            type: visibleAdmin ? '管理员' : '成员',
            origin: modal.args.origin,
            source: getTrackSource(modal.args.errType),
            buttonName: '关闭',
        });
        modal.hide();
    };
    return (React.createElement(Modal, { visible: !modal.hiding, maskClosable: false, title: "\u5347\u7EA7\u90AE\u7BB1\u7248\u672C", closeIcon: React.createElement(DeleteIcon, { className: "dark-invert" }), footer: null, width: "480px", wrapClassName: styles.paidGuideModal, onCancel: modalClose },
        TipsContent,
        React.createElement("p", { className: styles.tipBtnWrap },
            React.createElement(Button, { btnType: "primary", onClick: modalConfirm, loading: loading }, visibleAdmin ? '立即升级' : '立即通知管理员'))));
};
const PaidGuideModal = createNiceModal('paidGuide', PaidGuide);
const PaidGuidemodule = () => {
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [visibleAdmin, setVisibleAdmin] = useState(false);
    useEffect(() => {
        accountApi.doGetAccountIsAdmin().then(res => setVisibleAdmin(res));
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.paidGuideModalOut },
            React.createElement(PaidGuideModal, { setSuccessModalVisible: setSuccessModalVisible, visibleAdmin: visibleAdmin })),
        React.createElement(Modal, { visible: successModalVisible, title: React.createElement(React.Fragment, null), wrapClassName: styles.paidGuideSuccessModal, width: "480px", footer: null, onCancel: () => setSuccessModalVisible(false) },
            React.createElement("p", { className: styles.done },
                React.createElement(Done, null)),
            React.createElement("p", { className: styles.doneTxt }, "\u90AE\u4EF6\u5DF2\u53D1\u9001\uFF0C\u540C\u65F6\u5EFA\u8BAE\u60A8\u7EBF\u4E0B\u63D0\u9192\u4F01\u4E1A\u7BA1\u7406\u5458"),
            React.createElement("p", { className: styles.btnWrap },
                React.createElement(Button, { btnType: "primary", onClick: () => setSuccessModalVisible(false) }, "\u77E5\u9053\u4E86")))));
};
export default PaidGuidemodule;
